export default __webpack_public_path__ + "static/media/Jack_Rabbits_Loot_Documentation_March-24.fc1ded83.pdf";